module.exports = __webpack_public_path__ + "front/img/d15.4d19de32.png";